<template>
  <div class="u-bg--grey button-print" onclick="window.print()">
    <img src="@/assets/img/icons.svg#icon-print" width="16" height="16">
    <span class="u-color--blue">Imprimer</span>
  </div>
</template>

<script>
  export default {
    name: "PrintButton",
  }
</script>

<style lang="scss">
    .button-print {
      border-radius: rem(24px);
      border: 1px solid color(border);
      padding: rem(10px) rem(15px);
      display: flex;
      align-items: center;
      font-size: rem(14px);
      cursor: pointer;
      -webkit-print-color-adjust: exact;

      img {
        margin-right: rem(7px);
      }

      @include mq($until: MD) {
        padding: rem(10px);

        span {
          display: none;
        }

        img {
          margin: 0;
        }
      }
    }

    @media print {
      .header, .sticky-contact, .col-lg-4, .footer, .button-print {
        display: none;
      }
    }
</style>